<template>
    <div class="footermnuWebBurger" @click="ConfirmCloseSession">
        <h5 class="d-inline">
            <i class="pi pi-power-off" ></i>
            <span>{{ $t('globals.closesesion')}}</span>
        </h5>
        <span  class="d-inline versionMenu">
            ({{ version }})
        </span>                 
    </div>    
</template>
<script  setup lang="ts">
import { defineProps, defineEmits } from 'vue';
import { useConfirm } from "primevue/useconfirm";
import { traduceTexto } from '@/core/services/base/GlobalFunctios';

const closeSession = useConfirm();
defineProps(
{
 version: String
});
const emit = defineEmits(['onClose']);
const msg = 
{
    closesesion:traduceTexto('globals.closesesion'),
    closeSesionQuest:traduceTexto('globals.closeSesionQuest'),
    cancel:traduceTexto('globals.cancel'),
    aceptar:traduceTexto('globals.aceptar')
};
const ConfirmCloseSession = () => 
{
    closeSession.require({
        message: msg.closeSesionQuest,
        header: msg.closesesion,                
        rejectLabel: msg.cancel,
        acceptLabel: msg.aceptar,
        accept: () => {            
            emit('onClose',true);
        }
    });
}
</script>